import { fromJS } from 'immutable';

import { LOAD_WIZARD_USER_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  values: null,
});

const userWizardReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_WIZARD_USER_SUCCESS: {
      return state.set('values', fromJS(action.values));
    }
    default:
      return state;
  }
};

export default userWizardReducer;
